// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"5a4688e9","310":"79a7d6c6","362":"f06d937d","674":"87c5c55c","692":"77d7acee","808":"260a8d34","843":"3579619b"}[chunkId] + ".chunk.js";
};